const reportsPageDataAr = {
    header : {
        image : {
            src : "reports.jpg",
            alt : "",
        }
    },
    title : "التقارير",
    paragraphOne : "يلتزم بالبنك السعودي الأول بتزويد أصحاب المصلحة بالقدرة على الاطلاع على معلومات مفصلة عن مستوى أداء البنك على صعيد الممارسات البيئية والاجتماعية والحوكمة المؤسسية وكذلك عن مبادراته ومستوى التقدم الذي أحرزه. وتتوافق أنشطة إعداد التقارير لدينا الخاصة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية مع المعايير المعترف بها عالميًا، بما يُمكّن أصحاب المصلحة من تكوين رؤى عن جهودنا المبذولة للتخفيف من حدة المخاطر البيئية وتعزيز الأثر الاجتماعي للبنك وتقوية ممارسات الحوكمة لدينا. علاوة على ذلك، فإننا ندرك تمام الإدراك مدى أهمية تعريف أصحاب المصلحة بشكل فعال بالتزاماتنا في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية وبمستوى أداء البنك، ونحرص على توافق ممارسات إعداد التقارير لدينا مع منظومات الإفصاح الآخذة في التطور في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية.",
};

export default reportsPageDataAr;